import React from 'react';
import SaleCallOut from '../../../product/components/product-salecallout';
import ProductPrice from '../../../product/components/product-price';
import Link from '../../../shared/components/hyperlink';
import AdaptiveImage from '../../../shared/components/adaptive-image';
import './product-carousel-card.less';

const productCarouselCard = (props) => {
  const {product, setCarouselHeight} = props;

  const {imageUrl, name, linkUrl, violatorMsg, salePrice, listPrice} = product;

  return (
    <Link newTab={true} to={linkUrl} style={{textDecoration: "none", color: "black"}}>
      <div className='product-carousel-element'>
        <div className='product-carousel-image-container'>
        <div style={{height: "30px"}}>
          <SaleCallOut callout={violatorMsg} className="product-carousel-card"/>
        </div>
        <AdaptiveImage  
          className="product-carousel-image" 
          src={imageUrl} 
          onLoad={()=>setCarouselHeight}
          lazyload={true}
          maxWidth={150}
        />
        </div>
        <div className='product-carousel-detail-row'>
          <div className='product-carousel-card-name'>{name}</div>
            <ProductPrice product={product} pricePrefixText={"Starting at "}/>
        </div>
      </div>
    </Link>

  );
}

export default productCarouselCard;
